import React, { createContext, useContext, useState, useEffect } from "react";
import { auth, collections, db } from "../firebase-config"; // db is the Firestore database
import { onAuthStateChanged, signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import { getData } from "../utils/services";
import { collection, addDoc } from "firebase/firestore"; // Firestore functions
import AnimatedLoader from "../Components/AnimatedLoader/AnimatedLoader";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState("ADMIN");
  const [loading, setLoading] = useState(true);
  const [trigger, setTrigger] = useState(0);

  useEffect(() => {
    setLoading(true);
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user?.uid) {
        const userDoc = await getData(collections.USERS);
        const userDatas = userDoc?.find((items) => {
          return items?.uid === user?.uid;
        });
        if (userDoc) {
          setUser(userDatas);
          setRole(userDatas?.role);
        }
      } else {
        setUser(null);
        setRole(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, [trigger]);

  // Login function
  const login = async (data) => {
    const response = await signInWithEmailAndPassword(auth, data.email, data.password);
    setTrigger(trigger + 1);
    return response;
  };

  // Logout function
  const logout = async () => {
    await auth.signOut();
    setTrigger(trigger + 1);
  };

  // Register function (creating a user in Firestore)
  const register = async (data) => {
    try {
      // Create a new user with email and password
      const userCredential = await createUserWithEmailAndPassword(auth, data.email, data.password);

      // Create a user document in Firestore
      await addDoc(collection(db, collections.USERS), {
        uid: userCredential.user.uid,
        email: data.email,
        role: 'USER', // Default role, you can adjust as needed
        createdAt: new Date(),
      });
      await login(data);
    } catch (error) {
      console.error("Error creating user: ", error);
      throw error;
    }
  };

  return <AuthContext.Provider value={{ user, role, login, logout, register, setTrigger, trigger }}>{loading ? <AnimatedLoader /> : children}
</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
